
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { useCache } from "@bndes/bndes-ux4/bndes-angular-utils";

import { Observable } from 'rxjs';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { Dominio } from 'src/app/model/dominio-operacao.model';

@Injectable({
  providedIn: 'root'
})
export class DominiosService extends FgiBackEndService<any> {

  // @Override
  getNewEntity() {
    // o servico sera apenas para leitura
    return undefined;
  }

  // @Override
  protected getResourceURL(): string {
    return undefined;
  }

  // nao tem no BaseEntityService pra fazer override
  getDadosDominio() {
    return this.http.get(`rest/front/dados-dominio`, useCache()).pipe(
      catchError((e) => this.handleError(e))) as Observable<Dominio>;
  }

}
